// import * as Moment from 'dayjs';

export const COMMON_COLUMNS = [
  {
    title: '订单编号',
    dataIndex: 'code',
    key: 'code',
    width: 160,
    ellipsis: true,
    scopedSlots: { customRender: 'code' },
  },
  {
    title: '订单状态',
    dataIndex: 'status',
    key: 'status',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '订单收货/交付状态',
    dataIndex: 'receiveStatus',
    key: 'receiveStatus',
    width: 160,
    ellipsis: true,
    customRender: (text, row) => {
      return !row.receiveStatus ? '待交付' : '已交付';
    },
  },
  {
    title: '订单金额',
    dataIndex: 'total',
    key: 'total',
    width: 120,
    ellipsis: true,
    customRender: (text) => {
      return ![null, undefined].includes(text) ? text.toLocaleString() : '--';
    },
  },
  {
    title: '开票金额',
    dataIndex: 'invoiceAmount',
    key: 'invoiceAmount',
    width: 120,
    ellipsis: true,
    customRender: (text) => {
      return ![null, undefined].includes(text) ? text.toLocaleString() : '--';
    },
  },
  {
    title: '收款金额',
    dataIndex: 'collectionAmount',
    key: 'collectionAmount',
    width: 120,
    ellipsis: true,
    customRender: (text) => {
      return ![null, undefined].includes(text) ? text.toLocaleString() : '--';
    },
  },
  {
    title: '合同编号',
    dataIndex: 'contractCode',
    key: 'contractCode',
    width: 160,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '最终用户',
    dataIndex: 'finalCustomerName',
    key: 'finalCustomerName',
    width: 160,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '创建人',
    dataIndex: 'createUserName',
    key: 'createUserName',
    width: 140,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 180,
    ellipsis: true,
    // customRender: (text) => {
    //   return text ? Moment(text * 1).format('YYYY-MM-DD HH:mm:ss') : '--';
    // },
  },
  {
    title: '客户抬头',
    dataIndex: 'customerHead',
    key: 'customerHead',
    width: 160,
    ellipsis: true,
  },
];

export const SUB_COMMON_COLUMNS_SALE = [
  {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 160,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '规格',
    dataIndex: 'specification',
    key: 'specification',
    width: 160,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '型号',
    dataIndex: 'model',
    key: 'model',
    width: 160,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '数量',
    dataIndex: 'num',
    key: 'num',
    width: 160,
    ellipsis: true,
  },
  {
    title: '单价',
    dataIndex: 'taxPrice',
    key: 'taxPrice',
    width: 160,
    ellipsis: true,
    customRender: (text) => {
      return ![null, undefined].includes(text) ? text.toLocaleString() : '--';
    },
  },
  {
    title: '税率',
    dataIndex: 'taxRate',
    key: 'taxRate',
    width: 160,
    headAlign: 'left',
    align: 'left',
    ellipsis: true,
    customRender: (text) => {
      return ![null, undefined].includes(text) ? `${(text * 100).toFixed(2)}%` : '--';
    },
  },
];

export const SUB_COMMON_COLUMNS_PURCHASE = [
  {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 160,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '规格',
    dataIndex: 'specification',
    key: 'specification',
    width: 160,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '型号',
    dataIndex: 'model',
    key: 'model',
    width: 160,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '数量',
    dataIndex: 'currentBillingNum',
    key: 'currentBillingNum',
    width: 160,
    ellipsis: true,
  },
  {
    title: '单价',
    dataIndex: 'unitPrice',
    key: 'unitPrice',
    width: 160,
    ellipsis: true,
    customRender: (text) => {
      return ![null, undefined].includes(text) ? text.toLocaleString() : '--';
    },
  },
  {
    title: '税率',
    dataIndex: 'taxRate',
    key: 'taxRate',
    width: 160,
    headAlign: 'left',
    align: 'left',
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
];
